import React, {Component} from 'react';
import OrderingTableItem from './OrderingTableItem/OrderingTableItem';

export default class GroupedRopesOrderingTable extends Component {
  constructor (props) {
    super (props);

    this.state = {
      activeItemId: '',
    };

    this.handleActiveItemChange = this.handleActiveItemChange.bind (this);
  }

  handleActiveItemChange (itemId) {
    this.setState ({activeItemId: itemId});
  }

  render () {
    const {orderingItems} = this.props;
    return (
      <div>
        <p className="ordering-table__instruction">
          Select row to learn more about the product
        </p>
        <div className="main-product__table ordering-table">
          <table>
            <thead>
              <tr>
                <th>Diameter [mm]</th>
                <th>MBL Spliced [kN]</th>
                <th>MBL Unspliced [kN]</th>
                <th>MBL Spliced [metric ton]</th>
                <th>MBL Unspliced [metric ton]</th>
              </tr>
            </thead>
            <tbody>
              {orderingItems.map (item => (
                <OrderingTableItem
                  item={item}
                  key={item.Id}
                  activeItemId={this.state.activeItemId}
                  handleActiveItemChange={this.handleActiveItemChange}
                  open={this.state.activeItemId === item.Id}
                />
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}
